// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.commentaire-form {
  background: #fffdfc;
  margin-top: 5rem;
  display: flex;
  flex-direction: column;
}

.commentaire-form h3 {
  font-size: 1.6rem;
  font-weight: 600;
  margin-bottom: 1rem;
}

.commentaire-form textarea {
  width: 100%;
  padding: 1rem;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  resize: vertical;
  min-height: 100px;
  margin-bottom: 1rem;
  font-family: inherit;
  font-size: 1.6rem;
}

.commentaire-form textarea:focus {
  outline: none;
  border-color: #da7027;
  box-shadow: 0 0 0 2px rgba(218, 112, 39, 0.1);
}

.commentaire-form button {
  align-self: flex-end;
}
`, "",{"version":3,"sources":["webpack://./src/composants/CommentaireForm/CommentaireForm.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,oBAAoB;AACtB","sourcesContent":[".commentaire-form {\r\n  background: #fffdfc;\r\n  margin-top: 5rem;\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\n.commentaire-form h3 {\r\n  font-size: 1.6rem;\r\n  font-weight: 600;\r\n  margin-bottom: 1rem;\r\n}\r\n\r\n.commentaire-form textarea {\r\n  width: 100%;\r\n  padding: 1rem;\r\n  border: 1px solid #e5e7eb;\r\n  border-radius: 6px;\r\n  resize: vertical;\r\n  min-height: 100px;\r\n  margin-bottom: 1rem;\r\n  font-family: inherit;\r\n  font-size: 1.6rem;\r\n}\r\n\r\n.commentaire-form textarea:focus {\r\n  outline: none;\r\n  border-color: #da7027;\r\n  box-shadow: 0 0 0 2px rgba(218, 112, 39, 0.1);\r\n}\r\n\r\n.commentaire-form button {\r\n  align-self: flex-end;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
